import { useContext } from 'react';
import { UnitDataContext } from '../contexts/UnitDataProvider';

const useUnitData = () => (
  useContext(UnitDataContext)
);

export default useUnitData;
